export const SKIP_OPTION_ID = 0;
